export { createOverflowManager } from './overflowManager';
export { EMPTY_SNAPSHOT } from './consts';
export type {
  ObserveOptions,
  OverflowOptions,
  OnUpdateItemVisibility,
  OnUpdateItemVisibilityPayload,
  OnUpdateOverflow,
  OverflowAxis,
  OverflowDirection,
  OverflowEventPayload,
  OverflowGroupState,
  OverflowItemEntry,
  OverflowDividerEntry,
  OverflowManager,
  OverflowSnapshot,
} from './types';
